<template>
  <div>
    <el-form
      ref="shareForm"
      :model="shareForm"
      label-width="100px"
      class="demo-dynamic">
      <el-form-item
        :rules="pwdRule"
        prop="pwd"
        label="访问密码"
      >
        <div class="input-box">
          <el-input
            v-show="!logined"
            v-model="shareForm.pwd"
            maxlength="6"
            type="text"
            placeholder="请输入密码"
          />
          <span
            v-if="shareForm.pwd && shareForm.pwd.length>0 && !logined"
            class="sp-max">{{ shareForm.pwd.length }}/6</span>
        </div>
        <span class="sp-word" />
      </el-form-item>
      <el-form-item
        :rules="dayRule"
        prop="day"
        label="有效期"
      >
        <el-input
          v-model="shareForm.day"
          placeholder="请输入天数"
        />
        <span class="sp-word">天</span>
      </el-form-item>
    </el-form>
    <div>
      <el-button
        type="success"
        plain
        @click="handleSetLink"
      >生成链接</el-button>
      <div class="copy-box">
        <el-input
          :readonly="true"
          v-model="link"
          type="text" />

        <el-button
          v-clipboard:copy="link"
          v-clipboard:success="clipboardSuccessHandler"
          v-clipboard:error="clipboardErrorHandler"
          class="exec-link"
          type="info"
          plain
          @click="handleCopyLink(link)">复制链接</el-button>

        <span class="sp-word" />
      </div>
    </div>
    <!--<div-->
    <!--v-if="!logined"-->
    <!--class="btn-box">-->
    <!--<el-button @click="onClickCancel">取 消</el-button>-->
    <!--<span class="sp-space" />-->
    <!--<el-button-->
    <!--type="primary"-->
    <!--@click="submitForm('shareForm')">登 录</el-button>-->
    <!--</div>-->
  </div>
</template>

<script>
  import { Message } from "element-ui";
  import * as CourseListServer from "../../../api/courseList";
  import * as formUtils from "../../../utils/form";

  export default {
    name: "Share",
    props: {
      row: {
        type: Object,
      },
    },
    data() {
      return {
        // 表单字段
        shareForm: {
          day: "",
          pwd: "", // Math.round(Math.random() * 10000),
        },
        // 密码规则
        pwdRule: [
          { required: true, message: "请输入访问密码", trigger: "blur" },
          { validator: this.isNum, trigger: "blur" },
        ],
        // 密码规则
        dayRule: [
          { required: true, message: "请输入天数", trigger: "blur" },
          { validator: this.isNumAndNoZero, trigger: "blur" },
        ],
        // 链接地址
        link: "",
        // 是否已登录
        logined: false,
      };
    },
    methods: {
      // 判断连接是否为空
      handleCopyLink(link) {
        if (!link) Message.error("未生成连接");
      },
      // 判断是否为数字
      isNum(rule, value, callback) {
        const reg = /^[0-9]*$/;
        if (!reg.test(value)) {
          callback(new Error("只能为数字"));
        } else {
          callback();
        }
      },
      // 大于0数字
      isNumAndNoZero(rule, value, callback) {
        // const reg = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/;
        const reg = /^[1-9]\d*$/;
        if (!reg.test(value)) {
          callback(new Error("只能是大于0的正整数"));
        } else {
          callback();
        }
      },
      // 提交表单
      submitForm(formName) {
        const self = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            self.logined = true;
            return true;
          }
            console.log("error submit!!");
            self.logined = false;
            return false;
        });
      },
      // 取消
      onClickCancel() {
        this.$emit("onCancel");
      },
      // 生成链接
      handleSetLink() {
        console.log("生成链接==>");
        // 验证表单
        this.$refs.shareForm.validate(async (valid) => {
          if (valid) {
            // 获取公钥
            const res = await CourseListServer.createShareAdd({
              course_id: this.row.id,
              expire_days: this.shareForm.day,
              open_pwd: this.shareForm.pwd,
            });
            if (res) this.link = `${window.location.host}/share?theme_id=${this.row.theme_id}&id=${this.row.id}&code=${res}`;
          }
        });
      },
      // 复制成功
      clipboardSuccessHandler({ value, event }) {
        console.log("复制成功==>", value);
        this.$message.success("已复制");
      },
      // 复制失败
      clipboardErrorHandler({ value, event }) {
        console.log("复制失败==>", value);
        this.$message.error("复制失败");
      },
    },
  };
</script>

<style scoped>
.sp-word{
    width: 60px;
    text-align: left;
    margin-left: 10px;
}
.copy-box{
    display: flex;
    flex-direction: row;
    margin-top: 20px;
}
.exec-link{
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.sp-space{
    display: inline-block;
    width: 30px;
    height: 20px;
}
.btn-box{
    display: flex;
    flex-direction: row;
    justify-content: center;
}
  .input-box{
    width: 100%;
    position: relative;
  }
  .sp-max{
    position: absolute;
    right: 10px;
    color: #ccc;
  }
</style>
